import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { UserStorage } from '../services/storage/local-storage.model';
import { LocalStorageService } from '../services/storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class NavGuard implements CanActivate {
  protected readonly router = inject(Router);
  protected localStorageService = inject(LocalStorageService);


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user: UserStorage = this.localStorageService.getUser();
    if (!user.isAdmin && state.url == '/no-core-members') {
      this.router.navigate(['/']);
      return false;
    } else {
      return true;
    }
  }
}
